import { useEffect, useState } from "react";
import { getSubscriptionStatus } from "./subscription";

export function useSubscriptionStatus() {
  const [status, setStatus] = useState("none"); // "none" | "active" | "canceled"...
  const [planName, setPlanName] = useState(null);
  const [petLimit, setPetLimit] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const res = await getSubscriptionStatus();
        if (!mounted) return;
        setStatus(res.status || "none");
        setPlanName(res.planName || null);
        setPetLimit(res.petLimit ?? null);
      } catch (err) {
        console.error("Failed to load subscription status:", err);
        if (!mounted) return;
        setStatus("none");
        setPlanName(null);
        setPetLimit(null);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return { status, planName, petLimit, loading };
}
